import axios from "./axyos";
import type { CaptchaPayload } from "./registerApi";

export type AdCommentDto = {
  id: string;
  adsId?: string;
  userId?: string;
  authorName?: string;
  rating: number;
  content: string;
  valide?: boolean;
  adTitle?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type ListAdCommentsResponse = {
  data?: AdCommentDto[];
  count?: number;
  averageRating?: number;
  status?: number;
};

export const listAdCommentsApi = (adId: string) =>
  axios.get<ListAdCommentsResponse>(`/ads/${encodeURIComponent(adId)}/comments`);

export const saveAdCommentApi = (adId: string, payload: { rating: number; content?: string; captcha: CaptchaPayload }) =>
  axios.post(`/ads/${encodeURIComponent(adId)}/comments`, payload);

export const listCommentsForModerationApi = (valide = false, q = "") =>
  axios.get<{ data?: AdCommentDto[]; count?: number; status?: number }>("/comments/moderation", {
    params: { valide: String(valide), ...(q.trim() ? { q: q.trim() } : {}) },
  });

export const validateCommentByIdApi = (commentId: string, valide = true) =>
  axios.post(`/comments/${encodeURIComponent(commentId)}/validate`, { valide });
